export default "__VITE_ASSET__BdRnedvH__"